const configQueryReactSimpleRequest = {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: true,
    keepPreviousData: false,
};

export default configQueryReactSimpleRequest;
